import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { StorySection } from './components/StorySection';
import { RevelationSection } from './components/RevelationSection';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatYouGet } from './components/WhatYouGet';
import { BenefitsSection } from './components/BenefitsSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { PricingOffer } from './components/PricingOffer';
import { FinalCTA } from './components/FinalCTA';
import { EmotionalClose } from './components/EmotionalClose';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-celeste selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <OpeningHook data-id="element-3" />
        <StorySection data-id="element-4" />
        <RevelationSection data-id="element-5" />
        <ProductPresentation data-id="element-6" />
        <WhatYouGet data-id="element-7" />
        <BenefitsSection data-id="element-8" />
        <ObjectionsSection data-id="element-9" />
        <PricingOffer data-id="element-10" />
        <FinalCTA data-id="element-11" />
        <EmotionalClose data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}